import type { SelectedData } from '../dto/EntityRepository';

/** `workId`/`detailId` 조합으로 행을 식별 (스토어 `isSameSelection`와 동일 개념) */
export function selectedDataRowKey(item: SelectedData): string {
  return `${item.workId}\u0001${item.detailId ?? ''}`;
}

/**
 * `IndexWorkViewer`의 mergeIndexingDropAtSlot과 동일: `dropIndex` 앞 슬롯에 행들을 끼워 넣음.
 * `fromKeys`에 해당하는 행들은 현재 `orderedList` 안에서의 상대 순서를 유지한 채 블록으로 이동한다.
 */
export function moveItemsToIndexByKey<T>(
  orderedList: T[],
  getRowKey: (item: T) => string,
  fromKeys: string[],
  dropIndex: number
): T[] {
  const idKeys = fromKeys.map(String);
  if (idKeys.length === 0) return orderedList;

  const movingSet = new Set(idKeys);
  const blockOrder = orderedList.filter((item) => movingSet.has(getRowKey(item)));
  if (blockOrder.length === 0) return orderedList;

  const without = orderedList.filter((item) => !movingSet.has(getRowKey(item)));

  let insertAt = 0;
  for (let i = 0; i < dropIndex; i++) {
    const row = orderedList[i];
    if (!row) break;
    if (!movingSet.has(getRowKey(row))) insertAt++;
  }

  return [...without.slice(0, insertAt), ...blockOrder, ...without.slice(insertAt)];
}

export function moveItemsToIndex(
  orderedList: SelectedData[],
  fromKeys: string[],
  dropIndex: number
): SelectedData[] {
  return moveItemsToIndexByKey(orderedList, selectedDataRowKey, fromKeys, dropIndex);
}
